import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "5cc5d49d-c807-49c3-bf58-edc5801699c3",
    options: { imageDescription: "Observation", imageUrl: `${config.ASSETS_URL}/02/22/task/task-1-item-1.svg` },
  },
  {
    id: "383c43e8-7537-462b-a6d1-1ac00051bcc5",
    options: { imageDescription: "Theory", imageUrl: `${config.ASSETS_URL}/02/22/task/task-1-item-2.svg` },
  },
  {
    id: "6ce41893-4e1e-444d-a570-1f18e63efc15",
    options: { imageDescription: "Hypothesis", imageUrl: `${config.ASSETS_URL}/02/22/task/task-1-item-3.svg` },
  },
  {
    id: "6ddff3c8-5c28-4276-857b-857faecd8a7e",
    options: { imageDescription: "Experiment", imageUrl: `${config.ASSETS_URL}/02/22/task/task-1-item-4.svg` },
  },
  {
    id: "53087731-6453-4e8e-a7e0-51e47dffc407",
    options: { imageDescription: "Evaluation", imageUrl: `${config.ASSETS_URL}/02/22/task/task-1-item-5.svg` },
  },
  {
    id: "f2f12bd1-97d0-48e7-9668-f94051ce1f11",
    options: { imageDescription: "Conclusion", imageUrl: `${config.ASSETS_URL}/02/22/task/task-1-item-6.svg` },
  },
];

export const task: Task = {
  id: "b651c083-616d-49eb-922a-1046f299a580",
  solutionType: "order",
  type: "orderImages",
  options: {
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "5cc5d49d-c807-49c3-bf58-edc5801699c3",
    "383c43e8-7537-462b-a6d1-1ac00051bcc5",
    "6ce41893-4e1e-444d-a570-1f18e63efc15",
    "6ddff3c8-5c28-4276-857b-857faecd8a7e",
    "53087731-6453-4e8e-a7e0-51e47dffc407",
    "f2f12bd1-97d0-48e7-9668-f94051ce1f11",
  ],
};
